const DATES_DATA = [
    {
        name: 'Brother Martin Tournament',
        date: 'January 15, 2022'
    },
    {
        name: 'Baton Rouge Magnet High School Tournament',
        date: 'January 29, 2022'
    },
    {
        name: 'Catholic High School Tournament',
        date: 'February 5, 2022'
    },
    {
        name: 'Benjamin Franklin Tournament',
        date: 'February 16, 2022'
    },
    {
        name: 'Episcopal Tournament',
        date: 'February 19, 2022'
    },
    {
        name: 'Bolton High School Tournament',
        date: 'February 24, 2022'
    },
    {
        name: 'Louisiana Mu Alpha Theta State Convention',
        date: 'March 31 - April 2, 2022'
    },
    {
        name: 'AP Calculus AB/BC Exam',
        date: 'May 9, 2022'
    }
]

export default DATES_DATA;